import { Box } from "@mui/system";
import OrganizationProfileStepper from "views/shared/organization-profile-stepper";
import useOrganizationProfileStepper from "hooks/useOrganizationProfileStepper";

const OtherInformations = () => {
    const { submitUpdate, isReady } = useOrganizationProfileStepper();

    return (
        <Box mt={-3.5}>
            <OrganizationProfileStepper
                complete={false}
                onComplete={submitUpdate}
                actionsDisabled={!isReady}
            />
        </Box>
    );
};

export default OtherInformations;